import React from "react";
import "../../../css/Grupo3/G3Landing.css";
import Componente4 from "../../../Component/Grupo3/Componente4";

function Vista4() {
  return (
    <div className="wrapper">
      <Componente4 />
    </div>
  );
}

export default Vista4;
